import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { ErrorMessage, useFormik, FormikProvider, Field, } from "formik";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import HousingService from "../../../Services/HousingService";
import { Form, Row, Col, Table, } from "react-bootstrap";
import Swal from "sweetalert2";
import ShowAlert from "../../alert";
import { store } from "../../../App";
import { allowAlphabetAndSpacesOnly, NumberValidation, OnlyNumbers } from "../../utils/commonFunctions";

function EmpDetailsCommonEdit(props) {
  const history = useHistory();
  const showNotification = (type, message) => { if (type === "success") { Swal.fire("Success", message, "success"); } else if (type === "error") { Swal.fire("Error", message, "error"); } else if (type === "warning") { Swal.fire("Warning", message, "warning"); } else if (type === "info") { Swal.fire("info", message, "info"); } };


  const calculateDAPercentage = () => { const { basic_pay_earnings, da_earnings } = formik1.values; if (!basic_pay_earnings || !da_earnings) return 0; const percentage = (da_earnings / basic_pay_earnings) * 100; return percentage.toFixed(2); };
  const calculateHRAPercentage = () => { const { basic_pay_earnings, hra_earnings } = formik1.values; if (!basic_pay_earnings || !hra_earnings) return 0; const percentage = (hra_earnings / basic_pay_earnings) * 100; return percentage.toFixed(2); };
  const calculateIRPercentage = () => { const { basic_pay_earnings, ir_earnings } = formik1.values; if (!basic_pay_earnings || !ir_earnings) return 0; const percentage = (ir_earnings / basic_pay_earnings) * 100; return percentage.toFixed(2); };
  const calculateEPFPercentage = () => { const { basic_pay_earnings, epf_deductions } = formik1.values; if (!basic_pay_earnings || !epf_deductions) return 0; const percentage = (epf_deductions / basic_pay_earnings) * 100; return percentage.toFixed(2); };


  const fieldNames = ["basic_pay_earnings", "per_pay_earnings", "spl_pay_earnings", "da_earnings", "hra_earnings", "addl_hra", "cca_earnings", "ir_earnings", "medical_earnings", "ca_earnings", "spl_all", "misc_h_c", "sca",];
  const Earnings_3 = ["os_basic_pay_earnings", "os_hra_earnings", "os_medical_earnings", "os_ca_earnings", "os_performance_earnings", "os_ec_epf",];
  const Deductions_3 = ["os_prof_tax_deductions", "os_ees_epf_deductions", "os_ers_epf_deductions", "os_other_deductions",];
  const Earnings_4 = ["nmr_gross_earnings"];
  const Deductions_4 = ["nmr_tax_deductions", "nmr_tds_deductions", "nmr_fa_deductions", "nmr_ea_deductions", "nmr_ma_deductions", "nmr_lic_deductions", "nmr_otherliab_deductions", "os_ees_epf_deductions", "os_prof_tax_deductions", "nmr_postalrd_deductions",];
  const deductionNames = ["gpfs_deductions", "gpfsa_deductions", "gpfl_deductions", "apglis_deductions", "apglil_deductions", "gis_deductions", "lic_deductions", "license_deductions", "con_decd_deductions", "epf_deductions", "epf_deductions1", "epf_l_deductions", "vpf_deductions", "ppf_deductions", "rcs_cont_deductions", "cmrf_deductions", "fcf_deductions", "house_rent_deductions", "sal_rec_deductions", "pt_deductions", "it_deductions", "other_deductions",];
  const LoanDeductions = ["car_a_loanpi", "car_a_loanti", "car_a_loan", "car_i_loanpi", "car_i_loanti", "car_i_loan", "cyc_a_loanpi", "cyc_a_loanti", "cyc_a_loan", "cyc_i_loanpi", "cyc_i_loanti", "cyc_i_loan", "mca_a_loanpi", "mca_a_loanti", "mca_a_loan", "mca_i_loanpi", "mca_i_loanti", "mca_i_loan", "mar_a_loanti", "mar_a_loanti", "mar_a_loan", "mar_i_loanpi", "mar_i_loanti", "mar_i_loan", "med_a_loanpi", "med_a_loanti", "med_a_loan", "med_a_i_loanpi", "med_a_i_loanti", "med_a_i_loan", "hba_loanpi", "hba_loanti", "hba_loan", "add_hba_loanpi", "add_hba_loanti", "add_hba_loan", "hba1_loanpi", "hba1_loanti", "hba1_loan", "add_hba1_loanpi", "add_hba1_loanti", "add_hba1_loan", "comp_loanpi", "comp_loanti", "comp_loan", "comp1_loanpi", "comp1_loanti", "comp1_loan", "hcesa_loanpi", "hcesa_loanti", "hcesa_loan", "hcesa_i_loanpi", "hcesa_i_loanti", "hcesa_i_loan", "hbao_loanpi", "hbao_loanti", "hbao_loan", "vij_bank_loanpi", "vij_bank_loanti", "vij_bank_loan", "fa_loanpi", "fa_loanti", "fa_loan", "ea_loanpi", "ea_loanti", "ea_loan", "sfa_loanpi", "sfa_loanti", "sfa_loan", "sal_adv_loanpi", "sal_adv_loanti", "sal_adv_loan", "hr_arrear_loanpi", "hr_arrear_loanti", "hr_arrear_loan", "cell_loanpi", "cell_loanti", "cell_loan", "staff_pl_loanpi", "staff_pl_loanti", "staff_pl_loan", "court_loanpi", "court_loanti", "court_loan",];


  const formik1 = useFormik({
    initialValues: {
      emptype_id: "", district: "state", working_status: "", firstname: "", lastname: "", surname: "", fathername: "", sex: "", bank_name: "", ifsc: "",

      totalEarnings: "", totalDeductions: "", totalloanAdvances: "", totalDeductions_3: "", totalEarnings_3: "", netSalary: "", netSalary_3: "", totalDeductions_4: "", totalEarnings_4: "", netSalary_4: "", Earnings_4: "", Deductions_4: "", basic_pay_earnings: "", per_pay_earnings: "", spl_pay_earnings: "", da_earnings: "", hra_earnings: "", cca_earnings: "", gp_earnings: "", ir_earnings: "", medical_earnings: "", ca_earnings: "", spl_all: "", misc_h_c: "", addl_hra: "", sca: "",

      gpfs_deductions: "", gpfsa_deductions: "", gpfl_deductions: "", apglis_deductions: "", apglil_deductions: "", gis_deductions: "", lic_deductions: "", license_deductions: "", con_decd_deductions: "", epf_deductions: "", epf_deductions1: "", epf_l_deductions: "", vpf_deductions: "", ppf_deductions: "", rcs_cont_deductions: "", cmrf_deductions: "", fcf_deductions: "", house_rent_deductions: "", sal_rec_deductions: "", pt_deductions: "", it_deductions: "", other_deductions: "",

      car_a_loanpi: "", cyc_a_loanpi: "", mca_a_loanpi: "", mar_a_loanpi: "", med_a_loanpi: "", hba_loanpi: "", add_hba_loanpi: "", comp_loanpi: "", hcesa_loanpi: "", hcesa_loan: "", hbao_loanpi: "", fa_loanpi: "",

      hr_arrear_loanpi: "", staff_pl_loanpi: "", car_a_loanti: "", cyc_a_loanti: "", cyclePriTI: "", mca_a_loanti: "", mar_a_loanti: "", med_a_loanti: "", hba_loanti: "", add_hba_loanti: "", comp_loanti: "", hcesa_loanti: "", hbao_loanti: "", fa_loanti: "", sfa_loanti: "", hr_arrear_loanti: "", staff_pl_loanti: "",


      car_a_loan: "", cyclePriamount: "", mca_a_loan: "", mar_a_loan: "", med_a_loan: "", hba_loan: "", add_hba_loan: "", comp_loan: "", hcesaPriamount: "", hbao_loan: "", fa_loan: "",
      sfa_loan: "", hr_arrear_loan: "", staff_pl_loan: "",
      car_i_loanpi: "", cyc_i_loanpi: "", mca_i_loanpi: "", mar_i_loanpi: "", med_a_i_loanpi: "", hba1_loanpi: "", add_hba1_loanpi: "", comp1_loanti: "", hcesa_i_loanpi: "", vij_bank_loanpi: "", vij_bank_loanti: "", vij_bank_loan: "", faIntPI: "", ea_loanpi: "",
      sal_adv_loanpi: "", cell_loanpi: "", court_loanpi: "", sfa_loanpi: "", car_i_loanti: "", cyc_i_loanti: "", mca_i_loanti: "", mar_i_loanti: "", med_a_i_loanti: "", hba1_loanti: "", add_hba1_loanti: "", comp1_loanpi: "", hcesa_i_loanti: "", hbaotherIntTI: "", faIntTI: "", ea_loanti: "",
      sal_adv_loanti: "", cell_loanti: "", court_loanti: "", car_i_loan: "", cyc_i_loan: "", mca_i_loan: "", mar_i_loan: "", med_a_i_loan: "", hba1_loan: "", add_hba1_loan: "", comp1_loan: "", hcesa_i_loan: "", hbaotherIntAmount: "", faIntAmount: "", ea_loan: "",

      sal_adv_loan: "", cell_loan: "", court_loan: "", os_location: "", os_work_place: "", os_basic_pay_earnings: "", os_hra_earnings: "", os_medical_earnings: "", os_ca_earnings: "", os_performance_earnings: "", os_ec_epf: "", os_prof_tax_deductions: "", os_ees_epf_deductions: "", os_ers_epf_deductions: "", os_other_deductions: "", nmr_gross_earnings: "", nmr_tax_deductions: "", nmr_tds_deductions: "", nmr_fa_deductions: "", nmr_ea_deductions: "", nmr_ma_deductions: "", nmr_lic_deductions: "", nmr_otherliab_deductions: "", nmr_postalrd_deductions: "",
    },
    validate: (values) => {
      const errors = {};

      if (!values.emptype_id) {
        errors.emptype_id = "Select Employee Type";
      }

      if (!values.firstname) {
        errors.firstname = "First Name is required";
      }

      // if (!values.lastname) {
      //   errors.lastname = "Last Name is required";
      // }

      // if (!values.surname) {
      //   errors.surname = "Surname is required";
      // }

      if (!values.fathername) {
        errors.fathername = "Father Name is required";
      }

      if (!values.sex) {
        errors.sex = "Select Gender";
      }

      return errors;
    },

    onSubmit: async (values) => {
      if (values.district !== "0") { let distName = distData.filter((item) => item.code === values.district).map((item) => item.name); if (distName.length > 0) { setDisplaydist(distName[0]); } else { setDisplaydist("State"); } } else { setDisplaydist("All"); }
      let params = { district: formik1.values.district, emptype_id: formik1.values.emptype_id, };
      store.dispatch({ type: "SHOW_SPINNER" });

      await new Promise((resolve) => setTimeout(resolve, 2000));
      HousingService.ConfirmEmp_OnRolls_Report(params).then((res) => {
        settabledata(res.data); setSelectedList(res.data.map((item) => ({ emp_id: item.emp_id, working_status: item.working_status, })));
      });
      setTableEnable(true); setViewEnable(false);
      store.dispatch({ type: "HIDE_SPINNER" });
    },
  });
  const [saveID, setSaveID] = useState();

  const [prdesignationlist, setprdesignationlist] = useState();
  const [bankNamesList, setbankNamesList] = useState();
  const [EmpTypeList, setEmpTypeList] = useState();
  React.useEffect(() => {
    let params = { emptype_id: props.EmpType, emp_id: props.EmpId, payment_type: props.payType, confirm_month: props.confirmMonth, year: props.Year, };
    setSaveID(props.EmpType);

    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.ConfirmEmp_EmpName_Report(params).then((res) => {
      store.dispatch({ type: "HIDE_SPINNER" });

      formik1.setFieldValue("emp_id", res.data[0].emp_id);

      formik1.setFieldValue("prefix", res.data[0].prefix);
      formik1.setFieldValue("firstname", res.data[0].firstname);
      formik1.setFieldValue("lastname", res.data[0].lastname);
      formik1.setFieldValue("surname", res.data[0].surname);
      formik1.setFieldValue("fathername", res.data[0].fathername);
      formik1.setFieldValue("sex", res.data[0].sex);
      formik1.setFieldValue("emp_type", res.data[0].emp_type);
      formik1.setFieldValue("bank_name", res.data[0].bank_name);
      formik1.setFieldValue("designation", res.data[0].designation);
      formik1.setFieldValue("branch_code", res.data[0].branch_code);
      formik1.setFieldValue("account_no", res.data[0].account_no);
      formik1.setFieldValue("ifsc", res.data[0].ifsc);

      formik1.setFieldValue(
        "basic_pay_earnings",
        !res.data[0].basic_pay_earnings
          ? 0
          : parseFloat(res.data[0].basic_pay_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "per_pay_earnings",
        !res.data[0].per_pay_earnings
          ? 0
          : parseFloat(res.data[0].per_pay_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "spl_pay_earnings",
        !res.data[0].spl_pay_earnings
          ? 0
          : parseFloat(res.data[0].spl_pay_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "da_earnings",
        !res.data[0].da_earnings
          ? 0
          : parseFloat(res.data[0].da_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "da_earnings",
        !res.data[0].da_earnings
          ? 0
          : parseFloat(res.data[0].da_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "hra_earnings",
        !res.data[0].hra_earnings
          ? 0
          : parseFloat(res.data[0].hra_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "addl_hra",
        !res.data[0].addl_hra ? 0 : parseFloat(res.data[0].addl_hra).toFixed(2)
      );
      formik1.setFieldValue(
        "cca_earnings",
        !res.data[0].cca_earnings
          ? 0
          : parseFloat(res.data[0].cca_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "gp_earnings",
        !res.data[0].gp_earnings
          ? 0
          : parseFloat(res.data[0].gp_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "ir_earnings",
        !res.data[0].ir_earnings
          ? 0
          : parseFloat(res.data[0].ir_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "ir_earnings",
        !res.data[0].ir_earnings
          ? 0
          : parseFloat(res.data[0].ir_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "medical_earnings",
        !res.data[0].medical_earnings
          ? 0
          : parseFloat(res.data[0].medical_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "ca_earnings",
        !res.data[0].ca_earnings
          ? 0
          : parseFloat(res.data[0].ca_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "spl_all",
        !res.data[0].spl_all ? 0 : parseFloat(res.data[0].spl_all).toFixed(2)
      );
      formik1.setFieldValue(
        "misc_h_c",
        !res.data[0].misc_h_c ? 0 : parseFloat(res.data[0].misc_h_c).toFixed(2)
      );
      formik1.setFieldValue(
        "addl_hra",
        !res.data[0].addl_hra ? 0 : parseFloat(res.data[0].addl_hra).toFixed(2)
      );
      formik1.setFieldValue(
        "sca",
        !res.data[0].sca ? 0 : parseFloat(res.data[0].sca).toFixed(2)
      );

      formik1.setFieldValue(
        "gpfs_deductions",
        !res.data[0].gpfs_deductions
          ? 0
          : parseFloat(res.data[0].gpfs_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "gpfsa_deductions",
        !res.data[0].gpfsa_deductions
          ? 0
          : parseFloat(parseFloat(res.data[0].gpfsa_deductions)).toFixed(2)
      );
      formik1.setFieldValue(
        "gpfl_deductions",
        !res.data[0].gpfl_deductions
          ? 0
          : parseFloat(res.data[0].gpfl_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "apglis_deductions",
        !res.data[0].apglis_deductions
          ? 0
          : parseFloat(res.data[0].apglis_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "apglil_deductions",
        !res.data[0].apglil_deductions
          ? 0
          : parseFloat(res.data[0].apglil_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "gis_deductions",
        !res.data[0].gis_deductions
          ? 0
          : parseFloat(res.data[0].gis_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "lic_deductions",
        !res.data[0].lic_deductions
          ? 0
          : parseFloat(res.data[0].lic_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "license_deductions",
        !res.data[0].license_deductions
          ? 0
          : parseFloat(res.data[0].license_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "con_decd_deductions",
        !res.data[0].con_decd_deductions
          ? 0
          : parseFloat(res.data[0].con_decd_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "epf_deductions",
        !res.data[0].epf_deductions
          ? 0
          : parseFloat(res.data[0].epf_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "epf_deductions",
        !res.data[0].epf_deductions
          ? 0
          : parseFloat(res.data[0].epf_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "epf_l_deductions",
        !res.data[0].epf_l_deductions
          ? 0
          : parseFloat(res.data[0].epf_l_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "vpf_deductions",
        !res.data[0].vpf_deductions
          ? 0
          : parseFloat(res.data[0].vpf_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "ppf_deductions",
        !res.data[0].ppf_deductions
          ? 0
          : parseFloat(res.data[0].ppf_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "rcs_cont_deductions",
        !res.data[0].rcs_cont_deductions
          ? 0
          : parseFloat(res.data[0].rcs_cont_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "cmrf_deductions",
        !res.data[0].cmrf_deductions
          ? 0
          : parseFloat(res.data[0].cmrf_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "fcf_deductions",
        !res.data[0].fcf_deductions
          ? 0
          : parseFloat(res.data[0].fcf_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "house_rent_deductions",
        !res.data[0].house_rent_deductions
          ? 0
          : parseFloat(res.data[0].house_rent_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "sal_rec_deductions",
        !res.data[0].sal_rec_deductions
          ? 0
          : parseFloat(res.data[0].sal_rec_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "pt_deductions",
        !res.data[0].pt_deductions
          ? 0
          : parseFloat(res.data[0].pt_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "it_deductions",
        !res.data[0].it_deductions
          ? 0
          : parseFloat(res.data[0].it_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "other_deductions",
        !res.data[0].other_deductions
          ? 0
          : parseFloat(res.data[0].other_deductions).toFixed(2)
      );

      formik1.setFieldValue(
        "car_a_loanpi",
        !res.data[0].car_a_loanpi
          ? 0
          : parseFloat(res.data[0].car_a_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "car_a_loanti",
        !res.data[0].car_a_loanti
          ? 0
          : parseFloat(res.data[0].car_a_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "car_a_loan",
        !res.data[0].car_a_loan
          ? 0
          : parseFloat(res.data[0].car_a_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "car_i_loanpi",
        !res.data[0].car_i_loanpi
          ? 0
          : parseFloat(res.data[0].car_i_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "car_i_loanti",
        !res.data[0].car_i_loanti
          ? 0
          : parseFloat(res.data[0].car_i_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "car_i_loan",
        !res.data[0].car_i_loan
          ? 0
          : parseFloat(res.data[0].car_i_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "cyc_a_loanpi",
        !res.data[0].cyc_a_loanpi
          ? 0
          : parseFloat(res.data[0].cyc_a_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "cyc_a_loanti",
        !res.data[0].cyc_a_loanti
          ? 0
          : parseFloat(res.data[0].cyc_a_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "cyc_a_loan",
        !res.data[0].cyc_a_loan
          ? 0
          : parseFloat(res.data[0].cyc_a_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "cyc_i_loanpi",
        !res.data[0].cyc_i_loanpi
          ? 0
          : parseFloat(res.data[0].cyc_i_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "cyc_i_loanti",
        !res.data[0].cyc_i_loanti
          ? 0
          : parseFloat(res.data[0].cyc_i_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "cyc_i_loan",
        !res.data[0].cyc_i_loan
          ? 0
          : parseFloat(res.data[0].cyc_i_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "mca_a_loanpi",
        !res.data[0].mca_a_loanpi
          ? 0
          : parseFloat(res.data[0].mca_a_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "mca_a_loanti",
        !res.data[0].mca_a_loanti
          ? 0
          : parseFloat(res.data[0].mca_a_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "mca_a_loan",
        !res.data[0].mca_a_loan
          ? 0
          : parseFloat(res.data[0].mca_a_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "mca_i_loanpi",
        !res.data[0].mca_i_loanpi
          ? 0
          : parseFloat(res.data[0].mca_i_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "mca_i_loanti",
        !res.data[0].mca_i_loanti
          ? 0
          : parseFloat(res.data[0].mca_i_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "mca_i_loan",
        !res.data[0].mca_i_loan
          ? 0
          : parseFloat(res.data[0].mca_i_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "mar_a_loanpi",
        !res.data[0].mar_a_loanpi
          ? 0
          : parseFloat(res.data[0].mar_a_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "mar_a_loanti",
        !res.data[0].mar_a_loanti
          ? 0
          : parseFloat(res.data[0].mar_a_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "mar_a_loan",
        !res.data[0].mar_a_loan
          ? 0
          : parseFloat(res.data[0].mar_a_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "mar_i_loanpi",
        !res.data[0].mar_i_loanpi
          ? 0
          : parseFloat(res.data[0].mar_i_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "mar_i_loanti",
        !res.data[0].mar_i_loanti
          ? 0
          : parseFloat(res.data[0].mar_i_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "mar_i_loan",
        !res.data[0].mar_i_loan
          ? 0
          : parseFloat(res.data[0].mar_i_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "med_a_loanpi",
        !res.data[0].med_a_loanpi
          ? 0
          : parseFloat(res.data[0].med_a_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "med_a_loanti",
        !res.data[0].med_a_loanti
          ? 0
          : parseFloat(res.data[0].med_a_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "med_a_loan",
        !res.data[0].med_a_loan
          ? 0
          : parseFloat(res.data[0].med_a_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "med_a_i_loanpi",
        !res.data[0].med_a_i_loanpi
          ? 0
          : parseFloat(res.data[0].med_a_i_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "med_a_i_loanti",
        !res.data[0].med_a_i_loanti
          ? 0
          : parseFloat(res.data[0].med_a_i_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "med_a_i_loan",
        !res.data[0].med_a_i_loan
          ? 0
          : parseFloat(res.data[0].med_a_i_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "hba_loanpi",
        !res.data[0].hba_loanpi
          ? 0
          : parseFloat(res.data[0].hba_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "hba_loanti",
        !res.data[0].hba_loanti
          ? 0
          : parseFloat(res.data[0].hba_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "hba_loan",
        !res.data[0].hba_loan ? 0 : parseFloat(res.data[0].hba_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "hba1_loanpi",
        !res.data[0].hba1_loanpi
          ? 0
          : parseFloat(res.data[0].hba1_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "hba1_loanti",
        !res.data[0].hba1_loanti
          ? 0
          : parseFloat(res.data[0].hba1_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "hba1_loan",
        !res.data[0].hba1_loan
          ? 0
          : parseFloat(res.data[0].hba1_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "add_hba_loanpi",
        !res.data[0].add_hba_loanpi
          ? 0
          : parseFloat(res.data[0].add_hba_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "add_hba_loanti",
        !res.data[0].add_hba_loanti
          ? 0
          : parseFloat(res.data[0].add_hba_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "add_hba_loan",
        !res.data[0].add_hba_loan
          ? 0
          : parseFloat(res.data[0].add_hba_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "add_hba1_loanpi",
        !res.data[0].add_hba1_loanpi
          ? 0
          : parseFloat(res.data[0].add_hba1_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "add_hba1_loanti",
        !res.data[0].add_hba1_loanti
          ? 0
          : parseFloat(res.data[0].add_hba1_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "add_hba1_loan",
        !res.data[0].add_hba1_loan
          ? 0
          : parseFloat(res.data[0].add_hba1_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "comp_loanpi",
        !res.data[0].comp_loanpi
          ? 0
          : parseFloat(res.data[0].comp_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "comp_loanti",
        !res.data[0].comp_loanti
          ? 0
          : parseFloat(res.data[0].comp_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "comp_loan",
        !res.data[0].comp_loan
          ? 0
          : parseFloat(res.data[0].comp_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "comp1_loanpi",
        !res.data[0].comp1_loanpi
          ? 0
          : parseFloat(res.data[0].comp1_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "comp1_loanti",
        !res.data[0].comp1_loanti
          ? 0
          : parseFloat(res.data[0].comp1_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "comp1_loan",
        !res.data[0].comp1_loan
          ? 0
          : parseFloat(res.data[0].comp1_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "hcesa_loanpi",
        !res.data[0].hcesa_loanpi
          ? 0
          : parseFloat(res.data[0].hcesa_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "hcesa_loanti",
        !res.data[0].hcesa_loanti
          ? 0
          : parseFloat(res.data[0].hcesa_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "hcesa_loan",
        !res.data[0].hcesa_loan
          ? 0
          : parseFloat(res.data[0].hcesa_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "hcesa_i_loanpi",
        !res.data[0].hcesa_i_loanpi
          ? 0
          : parseFloat(res.data[0].hcesa_i_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "hcesa_i_loanti",
        !res.data[0].hcesa_i_loanti
          ? 0
          : parseFloat(res.data[0].hcesa_i_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "hcesa_i_loan",
        !res.data[0].hcesa_i_loan
          ? 0
          : parseFloat(res.data[0].hcesa_i_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "hbao_loanpi",
        !res.data[0].hbao_loanpi
          ? 0
          : parseFloat(res.data[0].hbao_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "hbao_loanti",
        !res.data[0].hbao_loanti
          ? 0
          : parseFloat(res.data[0].hbao_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "hbao_loan",
        !res.data[0].hbao_loan
          ? 0
          : parseFloat(res.data[0].hbao_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "vij_bank_loanpi",
        !res.data[0].vij_bank_loanpi
          ? 0
          : parseFloat(res.data[0].vij_bank_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "vij_bank_loanti",
        !res.data[0].vij_bank_loanti
          ? 0
          : parseFloat(res.data[0].vij_bank_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "vij_bank_loan",
        !res.data[0].vij_bank_loan
          ? 0
          : parseFloat(res.data[0].vij_bank_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "fa_loanpi",
        !res.data[0].fa_loanpi
          ? 0
          : parseFloat(res.data[0].fa_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "fa_loanti",
        !res.data[0].fa_loanti
          ? 0
          : parseFloat(res.data[0].fa_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "fa_loan",
        !res.data[0].fa_loan ? 0 : parseFloat(res.data[0].fa_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "ea_loanpi",
        !res.data[0].ea_loanpi
          ? 0
          : parseFloat(res.data[0].ea_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "ea_loanti",
        !res.data[0].ea_loanti
          ? 0
          : parseFloat(res.data[0].ea_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "ea_loan",
        !res.data[0].ea_loan ? 0 : parseFloat(res.data[0].ea_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "sfa_loanpi",
        !res.data[0].sfa_loanpi
          ? 0
          : parseFloat(res.data[0].sfa_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "sfa_loanti",
        !res.data[0].sfa_loanti
          ? 0
          : parseFloat(res.data[0].sfa_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "sfa_loan",
        !res.data[0].sfa_loan ? 0 : parseFloat(res.data[0].sfa_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "sal_adv_loanpi",
        !res.data[0].sal_adv_loanpi
          ? 0
          : parseFloat(res.data[0].sal_adv_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "sal_adv_loanti",
        !res.data[0].sal_adv_loanti
          ? 0
          : parseFloat(res.data[0].sal_adv_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "sal_adv_loan",
        !res.data[0].sal_adv_loan
          ? 0
          : parseFloat(res.data[0].sal_adv_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "hr_arrear_loanpi",
        !res.data[0].hr_arrear_loanpi
          ? 0
          : parseFloat(res.data[0].hr_arrear_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "hr_arrear_loanti",
        !res.data[0].hr_arrear_loanti
          ? 0
          : parseFloat(res.data[0].hr_arrear_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "hr_arrear_loan",
        !res.data[0].hr_arrear_loan
          ? 0
          : parseFloat(res.data[0].hr_arrear_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "cell_loanpi",
        !res.data[0].cell_loanpi
          ? 0
          : parseFloat(res.data[0].cell_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "cell_loanti",
        !res.data[0].cell_loanti
          ? 0
          : parseFloat(res.data[0].cell_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "cell_loan",
        !res.data[0].cell_loan
          ? 0
          : parseFloat(res.data[0].cell_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "staff_pl_loanpi",
        !res.data[0].staff_pl_loanpi
          ? 0
          : parseFloat(res.data[0].staff_pl_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "staff_pl_loanti",
        !res.data[0].staff_pl_loanti
          ? 0
          : parseFloat(res.data[0].staff_pl_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "staff_pl_loan",
        !res.data[0].staff_pl_loan
          ? 0
          : parseFloat(res.data[0].staff_pl_loan).toFixed(2)
      );

      formik1.setFieldValue(
        "court_loanpi",
        !res.data[0].court_loanpi
          ? 0
          : parseFloat(res.data[0].court_loanpi).toFixed(2)
      );
      formik1.setFieldValue(
        "court_loanti",
        !res.data[0].court_loanti
          ? 0
          : parseFloat(res.data[0].court_loanti).toFixed(2)
      );
      formik1.setFieldValue(
        "court_loan",
        !res.data[0].court_loan
          ? 0
          : parseFloat(res.data[0].court_loan).toFixed(2)
      );


      formik1.setFieldValue("os_location", res.data[0].os_location);
      formik1.setFieldValue("os_work_place", res.data[0].os_work_place);
      formik1.setFieldValue(
        "os_basic_pay_earnings",
        !res.data[0].os_basic_pay_earnings
          ? 0
          : parseFloat(res.data[0].os_basic_pay_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "os_hra_earnings",
        !res.data[0].os_hra_earnings
          ? 0
          : parseFloat(res.data[0].os_hra_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "os_medical_earnings",
        !res.data[0].os_medical_earnings
          ? 0
          : parseFloat(res.data[0].os_medical_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "os_ca_earnings",
        !res.data[0].os_ca_earnings
          ? 0
          : parseFloat(res.data[0].os_ca_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "os_performance_earnings",
        !res.data[0].os_performance_earnings
          ? 0
          : parseFloat(res.data[0].os_performance_earnings).toFixed(2)
      );
      formik1.setFieldValue(
        "os_ec_epf",
        !res.data[0].os_ec_epf
          ? 0
          : parseFloat(res.data[0].os_ec_epf).toFixed(2)
      );
      formik1.setFieldValue(
        "os_prof_tax_deductions",
        !res.data[0].os_prof_tax_deductions
          ? 0
          : parseFloat(res.data[0].os_prof_tax_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "os_ees_epf_deductions",
        !res.data[0].os_ees_epf_deductions
          ? 0
          : parseFloat(res.data[0].os_ees_epf_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "os_ers_epf_deductions",
        !res.data[0].os_ers_epf_deductions
          ? 0
          : parseFloat(res.data[0].os_ers_epf_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "os_other_deductions",
        !res.data[0].os_other_deductions
          ? 0
          : parseFloat(res.data[0].os_other_deductions).toFixed(2)
      );


      formik1.setFieldValue(
        "os_prof_tax_deductions",
        !res.data[0].os_prof_tax_deductions
          ? 0
          : parseFloat(res.data[0].os_prof_tax_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "nmr_gross_earnings",
        !res.data[0]?.nmr_gross_earnings
          ? 0
          : parseFloat(res.data[0]?.nmr_gross_earnings).toFixed(2)
      );

      formik1.setFieldValue(
        "nmr_tds_deductions",
        !res.data[0].nmr_tds_deductions
          ? 0
          : parseFloat(res.data[0].nmr_tds_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "nmr_fa_deductions",
        !res.data[0].nmr_fa_deductions
          ? 0
          : parseFloat(res.data[0].nmr_fa_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "nmr_ea_deductions",
        !res.data[0].nmr_ea_deductions
          ? 0
          : parseFloat(res.data[0].nmr_ea_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "nmr_ma_deductions",
        !res.data[0].nmr_ma_deductions
          ? 0
          : parseFloat(res.data[0].nmr_ma_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "nmr_lic_deductions",
        !res.data[0].nmr_lic_deductions
          ? 0
          : parseFloat(res.data[0].nmr_lic_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "nmr_otherliab_deductions",
        !res.data[0].nmr_otherliab_deductions
          ? 0
          : parseFloat(res.data[0].nmr_otherliab_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "nmr_postalrd_deductions",
        !res.data[0].nmr_postalrd_deductions
          ? 0
          : parseFloat(res.data[0].nmr_postalrd_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "nmr_tax_deductions",
        !res.data[0].nmr_tax_deductions
          ? 0
          : parseFloat(res.data[0].nmr_tax_deductions).toFixed(2)
      );
      formik1.setFieldValue(
        "nmr_tds_deductions",
        !res.data[0].nmr_tds_deductions
          ? 0
          : parseFloat(res.data[0].nmr_tds_deductions).toFixed(2)
      );
    });
    HousingService.getCadreWiseDesignationDropdownlist().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          if (item !== null) {
            return (
              <option key={i} value={item.designation_id}>
                {item.designation_name}
              </option>
            );
          }
        });
        setprdesignationlist(options);
      }
    });
    HousingService.fetchBankName().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          if (item !== null) {
            return (
              <option key={i} value={item.bankid}>
                {item.bankfullname}
              </option>
            );
          }
        });
        setbankNamesList(options);
      }
    });
    HousingService.fetchEmptypeList().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.emptype_id}>
              {item.emptype_name}
            </option>
          );
        });
        setEmpTypeList(options);
      }
    });
  }, []);
  const sumFieldNames = fieldNames.reduce(
    (total, fieldName) => total + parseFloat(formik1.values[fieldName] || 0),
    0
  );
  const sumDeductions = deductionNames.reduce(
    (total, deductionName) =>
      total + parseFloat(formik1.values[deductionName] || 0),
    0
  );
  const sumLoanDeductions = LoanDeductions.reduce(
    (total, LoanDeduction) =>
      total + parseFloat(formik1.values[LoanDeduction] || 0),
    0
  );
  const totalSum = sumFieldNames - sumDeductions - sumLoanDeductions;

  const sumFieldNames_3 = Earnings_3.reduce(
    (total, Earnings_3) => total + parseFloat(formik1.values[Earnings_3] || 0),
    0
  );
  const sumDeductions_3 = Deductions_3.reduce(
    (total, Deductions_3) =>
      total + parseFloat(formik1.values[Deductions_3] || 0),
    0
  );

  const totalSum_3 = sumFieldNames_3 - sumDeductions_3;

  const sumFieldNames_4 = Earnings_4.reduce(
    (total, Earnings_4) => total + parseFloat(formik1.values[Earnings_4] || 0),
    0
  );
  const sumDeductions_4 = Deductions_4.reduce(
    (total, Deductions_4) =>
      total + parseFloat(formik1.values[Deductions_4] || 0),
    0
  );

  const totalSum_4 = sumFieldNames_4 - sumDeductions_4;

  const ConfirmEmpUpdateReport = () => {

    if (!formik1.values.firstname?.trim()) {
      Swal.fire("Alert", "First Name is mandatory", "warning");
      return;
    }

    if (!formik1.values.surname?.trim()) {
      Swal.fire("Alert", "Surname is mandatory", "warning");
      return;
    }

    if (!formik1.values.fathername?.trim()) {
      Swal.fire("Alert", "Father Name is mandatory", "warning");
      return;
    }

    let param1 = {

      emp_id: props.EmpId,
      payment_type: props.payType,
      confirm_month: props.confirmMonth,
      year: props.Year,
      prefix: formik1.values.prefix,
      firstname: formik1.values.firstname,
      lastname: formik1.values.lastname,
      surname: formik1.values.surname,
      fathername: formik1.values.fathername,
      emptype_id: saveID,
      sex: formik1.values.sex,
      designation: formik1.values.designation,
      account_no: formik1.values.account_no,
      others: formik1.values.others,
      bank_name: formik1.values.bank_name,
      branch_code: formik1.values.branch_code,
      ifsc: formik1.values.ifsc,

      basic_pay_earnings: formik1.values.basic_pay_earnings,
      per_pay_earnings: formik1.values.per_pay_earnings,
      spl_pay_earnings: formik1.values.spl_pay_earnings,
      da_earnings: formik1.values.da_earnings,
      hra_earnings: formik1.values.hra_earnings,
      cca_earnings: formik1.values.cca_earnings,
      gp_earnings: formik1.values.gp_earnings,
      ir_earnings: formik1.values.ir_earnings,
      medical_earnings: formik1.values.medical_earnings,
      ca_earnings: formik1.values.ca_earnings,
      spl_all: formik1.values.spl_all,
      misc_h_c: formik1.values.misc_h_c,
      addl_hra: formik1.values.addl_hra,
      sca: formik1.values.sca,


      gpfs_deductions: formik1.values.gpfs_deductions,
      gpfl_deductions: formik1.values.gpfl_deductions,
      gpfsa_deductions: formik1.values.gpfsa_deductions,
      house_rent_deductions: formik1.values.house_rent_deductions,
      gis_deductions: formik1.values.gis_deductions,
      pt_deductions: formik1.values.pt_deductions,
      it_deductions: formik1.values.it_deductions,
      cca_deductions: formik1.values.cca_deductions,
      license_deductions: formik1.values.license_deductions,
      con_decd_deductions: formik1.values.con_decd_deductions,
      lic_deductions: formik1.values.lic_deductions,
      rcs_cont_deductions: formik1.values.rcs_cont_deductions,
      sal_rec_deductions: formik1.values.sal_rec_deductions,
      cmrf_deductions: formik1.values.cmrf_deductions,
      fcf_deductions: formik1.values.fcf_deductions,
      epf_l_deductions: formik1.values.epf_l_deductions,
      vpf_deductions: formik1.values.vpf_deductions,
      apglis_deductions: formik1.values.apglis_deductions,
      apglil_deductions: formik1.values.apglil_deductions,
      epf_deductions: formik1.values.epf_deductions,
      ppf_deductions: formik1.values.ppf_deductions,
      other_deductions: formik1.values.other_deductions,

      car_a_loan: formik1.values.car_a_loan,
      car_a_loanpi: formik1.values.car_a_loanpi,
      car_a_loanti: formik1.values.car_a_loanti,

      car_i_loanpi: formik1.values.car_i_loanpi,
      car_i_loanti: formik1.values.car_i_loanti,
      car_i_loan: formik1.values.car_i_loan,

      cyc_i_loanpi: formik1.values.cyc_i_loanpi,
      cyc_i_loanti: formik1.values.cyc_i_loanti,
      cyc_i_loan: formik1.values.cyc_i_loan,

      cyc_a_loanpi: formik1.values.cyc_a_loanpi,
      cyc_a_loanti: formik1.values.cyc_a_loanti,
      cyc_a_loan: formik1.values.cyc_a_loan,

      mca_i_loanpi: formik1.values.mca_i_loanpi,
      mca_i_loanti: formik1.values.mca_i_loanti,
      mca_i_loan: formik1.values.mca_i_loan,

      mca_a_loanpi: formik1.values.mca_a_loanpi,
      mca_a_loanti: formik1.values.mca_a_loanti,
      mca_a_loan: formik1.values.mca_a_loan,

      mar_a_loanpi: formik1.values.mar_a_loanpi,
      mar_a_loanti: formik1.values.mar_a_loanti,
      mar_a_loan: formik1.values.mar_a_loan,

      mar_i_loanpi: formik1.values.mar_i_loanpi,
      mar_i_loanti: formik1.values.mar_i_loanti,
      mar_i_loan: formik1.values.mar_i_loan,

      med_a_loanpi: formik1.values.med_a_loanpi,
      med_a_loanti: formik1.values.med_a_loanti,
      med_a_loan: formik1.values.med_a_loan,

      med_a_i_loanpi: formik1.values.med_a_i_loanpi,
      med_a_i_loanti: formik1.values.med_a_i_loanti,
      med_a_i_loan: formik1.values.med_a_i_loan,

      hba_loanpi: formik1.values.hba_loanpi,
      hba_loanti: formik1.values.hba_loanti,
      hba_loan: formik1.values.hba_loan,

      hba1_loanpi: formik1.values.hba1_loanpi,
      hba1_loanti: formik1.values.hba1_loanti,
      hba1_loan: formik1.values.hba1_loan,

      add_hba_loanpi: formik1.values.add_hba_loanpi,
      add_hba_loanti: formik1.values.add_hba_loanti,
      add_hba_loan: formik1.values.add_hba_loan,

      comp_loanpi: formik1.values.comp_loanpi,
      comp_loanti: formik1.values.comp_loanti,
      comp_loan: formik1.values.comp_loan,

      comp1_loanpi: formik1.values.comp1_loanpi,
      comp1_loanti: formik1.values.comp1_loanti,
      comp1_loan: formik1.values.comp1_loan,

      hcesa_loanpi: formik1.values.hcesa_loanpi,
      hcesa_loanti: formik1.values.hcesa_loanti,
      hcesa_loan: formik1.values.hcesa_loan,

      hcesa_i_loanpi: formik1.values.hcesa_i_loanpi,
      hcesa_i_loanti: formik1.values.hcesa_i_loanti,
      hcesa_i_loan: formik1.values.hcesa_i_loan,

      hbao_loanpi: formik1.values.hbao_loanpi,
      hbao_loanti: formik1.values.hbao_loanti,
      hbao_loan: formik1.values.hbao_loan,

      vij_bank_loanpi: formik1.values.vij_bank_loanpi,
      vij_bank_loanti: formik1.values.vij_bank_loanti,
      vij_bank_loan: formik1.values.vij_bank_loan,

      fa_loanpi: formik1.values.fa_loanpi,
      fa_loanti: formik1.values.fa_loanti,
      fa_loan: formik1.values.fa_loan,

      ea_loanpi: formik1.values.ea_loanpi,
      ea_loanti: formik1.values.ea_loanti,
      ea_loan: formik1.values.ea_loan,

      sal_adv_loanpi: formik1.values.sal_adv_loanpi,
      sal_adv_loanti: formik1.values.sal_adv_loanti,
      sal_adv_loan: formik1.values.sal_adv_loan,

      hr_arrear_loanpi: formik1.values.hr_arrear_loanpi,
      hr_arrear_loanti: formik1.values.hr_arrear_loanti,
      hr_arrear_loan: formik1.values.hr_arrear_loan,

      cell_loanpi: formik1.values.cell_loanpi,
      cell_loanti: formik1.values.cell_loanti,
      cell_loan: formik1.values.cell_loan,

      staff_pl_loanpi: formik1.values.staff_pl_loanpi,
      staff_pl_loanti: formik1.values.staff_pl_loanti,
      staff_pl_loan: formik1.values.staff_pl_loan,

      court_loanpi: formik1.values.court_loanpi,
      court_loanti: formik1.values.court_loanti,
      court_loan: formik1.values.court_loan,

      sfa_loanpi: formik1.values.sfa_loanpi,
      sfa_loanti: formik1.values.sfa_loanti,
      sfa_loan: formik1.values.sfa_loan,

      add_hba1_loan: formik1.values.add_hba1_loan,
      add_hba1_loanpi: formik1.values.add_hba1_loanpi,
      add_hba1_loanti: formik1.values.add_hba1_loanti,
    };
    Swal.fire({
      text: "Do you want to Update?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        store.dispatch({ type: "SHOW_SPINNER" });
        HousingService.ConfirmEmp_Update_Report1(param1).then((res) => {
          if (res.data.SCODE === "01") {
            showNotification("success", "Confirmed successfully");
            store.dispatch({ type: "HIDE_SPINNER" });
            ShowAlert(res.data.SDESC, "success");
            // history.go(0);
          }
        });
      }
    });
  };
  const ConfirmEmpUpdateReport3 = () => {

    if (!formik1.values.firstname?.trim()) { Swal.fire("Alert", "First Name is mandatory", "warning"); return; } if (!formik1.values.surname?.trim()) { Swal.fire("Alert", "Surname is mandatory", "warning"); return; }

    if (!formik1.values.fathername?.trim()) {
      Swal.fire("Alert", "Father Name is mandatory", "warning");
      return;
    }

    let param3 = {
      emp_id: props.EmpId,
      payment_type: props.payType,
      confirm_month: props.confirmMonth,
      year: props.Year,
      prefix: formik1.values.prefix,
      firstname: formik1.values.firstname,
      lastname: formik1.values.lastname,
      surname: formik1.values.surname,
      fathername: formik1.values.fathername,
      emptype_id: saveID,
      sex: formik1.values.sex,
      designation: formik1.values.designation,
      account_no: formik1.values.account_no,
      others: formik1.values.others,
      bank_name: formik1.values.bank_name,
      branch_code: formik1.values.branch_code,
      ifsc: formik1.values.ifsc,

      os_work_place: formik1.values.os_work_place,
      os_location: formik1.values.os_location,

      os_basic_pay_earnings: formik1.values.os_basic_pay_earnings,
      os_hra_earnings: formik1.values.os_hra_earnings,
      os_medical_earnings: formik1.values.os_medical_earnings,

      os_ca_earnings: formik1.values.os_ca_earnings,
      os_performance_earnings: formik1.values.os_performance_earnings,
      os_ec_epf: formik1.values.os_ec_epf,

      os_prof_tax_deductions: formik1.values.os_prof_tax_deductions,
      os_ees_epf_deductions: formik1.values.os_ees_epf_deductions,
      os_ers_epf_deductions: formik1.values.os_ers_epf_deductions,

      os_other_deductions: formik1.values.os_other_deductions,
    };
    Swal.fire({
      text: "Are You Sure Want to Submit?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        store.dispatch({ type: "SHOW_SPINNER" });
        HousingService.ConfirmEmp_Update_Report3(param3).then((res) => {
          if (res.data.SCODE === "01") {
            showNotification("success", "Confirmed successfully");
            store.dispatch({ type: "HIDE_SPINNER" });
            ShowAlert(res.data.SDESC, "success");
            // history.go(0);
          }
        });
      }
    });
  };
  const ConfirmEmpUpdateReport4 = () => {

    if (!formik1.values.firstname?.trim()) { Swal.fire("Alert", "First Name is mandatory", "warning"); return; } if (!formik1.values.surname?.trim()) { Swal.fire("Alert", "Surname is mandatory", "warning"); return; } if (!formik1.values.fathername?.trim()) { Swal.fire("Alert", "Father Name is mandatory", "warning"); return; }

    let param4 = {
      emp_id: props.EmpId,
      payment_type: props.payType,
      confirm_month: props.confirmMonth,
      year: props.Year,

      prefix: formik1.values.prefix,
      firstname: formik1.values.firstname,
      lastname: formik1.values.lastname,
      surname: formik1.values.surname,
      fathername: formik1.values.fathername,
      emptype_id: saveID,
      sex: formik1.values.sex,
      designation: formik1.values.designation,
      account_no: formik1.values.account_no,
      bank_name: formik1.values.bank_name,
      branch_code: formik1.values.branch_code,
      ifsc: formik1.values.ifsc,
      os_work_place: formik1.values.os_work_place,
      os_location: formik1.values.os_location,
      
      nmr_gross_earnings: formik1.values.nmr_gross_earnings,
      os_ees_epf_deductions: formik1.values.os_ees_epf_deductions,
      os_prof_tax_deductions: formik1.values.os_prof_tax_deductions,
      nmr_postalrd_deductions: formik1.values.nmr_postalrd_deductions,

      nmr_tds_deductions: formik1.values.nmr_tds_deductions,
      nmr_fa_deductions: formik1.values.nmr_fa_deductions,
      nmr_ea_deductions: formik1.values.nmr_ea_deductions,

      nmr_ma_deductions: formik1.values.nmr_ma_deductions,
      nmr_lic_deductions: formik1.values.nmr_lic_deductions,
      nmr_otherliab_deductions: formik1.values.nmr_otherliab_deductions,
    };
    Swal.fire({
      text: "Are You Sure Want to Submit?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        store.dispatch({ type: "SHOW_SPINNER" });
        HousingService.ConfirmEmp_Update_Report4(param4)
          .then((res) => {
            if (res.data.SCODE === "01") {
              showNotification("success", "Confirmed successfully");
              store.dispatch({ type: "HIDE_SPINNER" });
              // history.go(0);
            }
          })
          .catch((error) => {
            ShowAlert(error.message, "error");
          });
      }
    });
  };


  return (
    <>

      <OFMSUI.Container className="outer-page-content-container" fluid>
        <FormikProvider value={formik1}>
          <Form onSubmit={formik1.handleSubmit}>
            <>
              <div style={{ textAlign: "left" }}>
                <h5 style={{ color: "#004687" }}>
                  <b style={{ color: "#0e6793" }}>
                    <u>
                      {" "}
                      <h4 style={{ fontFamily: "times new roman" }}>
                        Personal Details
                      </h4>
                    </u>
                  </b>
                </h5>
              </div>
              <div class="col-md-60">
                <Row>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <th style={{ fontFamily: "roboto" }}>Employee ID</th>

                    <Field
                      name="emp_id"
                      className={
                        formik1.touched.emp_id && formik1.errors.emp_id
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <th style={{ fontFamily: "roboto" }}>Prefix</th>

                    <Field
                      name="prefix"
                      component="select"
                      className={
                        formik1.touched.prefix && formik1.errors.prefix
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      onChange={formik1.handleChange}
                    >
                      <option value="">Select</option>

                                            <option value="MR">MR</option>
                      <option value="Mrs.">Mrs.</option>
                      <option value="SMT">SMT</option>
                      <option value="Mr.">Mr.</option>
                      <option value="Ms.">Ms.</option>
                      <option value="Smt">Smt</option>
                      <option value="Mr">Mr</option>
                      <option value="Sri">Sri</option>
                    </Field>
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <th style={{ fontFamily: "roboto" }}> First Name</th>

                    <Field
                      name="firstname"
                      onChange={(e) => {
                        formik1.handleChange(e);
                      }}
                      onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                      maxLength={50}
                      type="text"
                      className={
                        formik1.touched.firstname && formik1.errors.firstname
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                    />
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <th style={{ fontFamily: "roboto" }}>Last Name</th>

                    <Field
                      name="lastname"
                      onChange={(e) => {
                        formik1.handleChange(e);
                      }}
                      onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                      maxLength={50}
                      type="text"
                      className={
                        formik1.touched.lastname && formik1.errors.lastname
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                    />
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <th style={{ fontFamily: "roboto" }}>Surname</th>

                    <Field
                      name="surname"
                      onChange={(e) => {
                        formik1.handleChange(e);
                      }}
                      onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                      maxLength={50}
                      type="text"
                      className={
                        formik1.touched.surname && formik1.errors.surname
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                    />
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <th style={{ fontFamily: "roboto" }}>Father name:</th>

                    <Field
                      name="fathername"
                      onChange={(e) => {
                        formik1.handleChange(e);
                      }}
                      onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                      maxLength={50}
                      type="text"
                      className={
                        formik1.touched.fathername && formik1.errors.fathername
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                    />
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <th style={{ fontFamily: "roboto" }}>Sex</th>

                    <Field
                      name="sex"
                      component="select"
                      onChange={(e) => {
                        formik1.handleChange(e);
                      }}
                      className={
                        formik1.touched.sex && formik1.errors.sex
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                    >
                      <option value="">Select</option>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                    </Field>
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <th style={{ fontFamily: "roboto" }}> Employee Type</th>

                    <Field
                      name="emp_type"
                      className={
                        formik1.touched.emp_type && formik1.errors.emp_type
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      onChange={(e) => {
                        formik1.handleChange(e);
                      }}
                      component="select"
                      disabled={true}
                    >
                      <option>Select</option>
                      {EmpTypeList}
                    </Field>
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <th style={{ fontFamily: "roboto" }}>Bank Name</th>

                    <Field
                      component="select"
                      name="bank_name"
                      onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                      maxLength={50}
                      className={
                        formik1.touched.bank_name && formik1.errors.bank_name
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                    >
                      <option value="">--Select--</option>
                      {bankNamesList}
                    </Field>
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <th style={{ fontFamily: "roboto" }}>Designation</th>

                    <Field
                      name="designation"
                      component="select"
                      onChange={(e) => {
                        formik1.handleChange(e);
                      }}
                      className={
                        formik1.touched.designation && formik1.errors.designation
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                    >
                      <option value="">Select</option>
                      {prdesignationlist}
                    </Field>
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <th style={{ fontFamily: "roboto" }}>Branch Code</th>

                    <Field
                      name="branch_code"
                      onChange={(e) => {
                        formik1.handleChange(e);
                      }}
                      onKeyPress={OnlyNumbers}
                      maxLength={10}
                      className={
                        formik1.touched.branch_code && formik1.errors.branch_code
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                    />
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <th style={{ fontFamily: "roboto" }}>Account No.</th>

                    <Field
                      name="account_no"
                      onChange={(e) => {
                        formik1.handleChange(e);
                      }}
                      onKeyPress={OnlyNumbers}
                      maxLength={24}
                      minLength={11}
                      type="text"
                      className={
                        formik1.touched.account_no && formik1.errors.account_no
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                    />
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <th style={{ fontFamily: "roboto" }}>IFSC Code</th>

                    <Field
                      name="ifsc"
                      onChange={(e) => {
                        formik1.handleChange(e);
                      }}
                      type="text"
                      className={
                        formik1.touched.ifsc && formik1.errors.ifsc
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                    />
                  </Col>
                </Row>
              </div>
              {(saveID === "1" || saveID === "2" || saveID === "5") && (
                <>
                  <div style={{ textAlign: "left" }}>
                    <h5 style={{ color: "#004687" }}>
                      <b style={{ color: "#0e6793" }}>
                        <u>
                          {" "}
                          <h4 style={{ fontFamily: "times new roman" }}>
                            Earnings
                          </h4>
                        </u>
                      </b>
                    </h5>
                  </div>

                  <div class="col-md-60" id="fieldName">
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> Basic Pay</th>

                        <Field
                          name="basic_pay_earnings"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          className={
                            formik1.touched.basic_pay_earnings &&
                              formik1.errors.basic_pay_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> Personal Pay</th>

                        <Field
                          name="per_pay_earnings"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          className={
                            formik1.touched.per_pay_earnings &&
                              formik1.errors.per_pay_earningsearnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Special Pay</th>

                        <Field
                          name="spl_pay_earnings"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          className={
                            formik1.touched.spl_pay_earnings &&
                              formik1.errors.spl_pay_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={1}
                        xl={1}
                        xxl={1}
                        className=""
                      >
                        {" "}
                        <th style={{ fontFamily: "roboto" }}>D.A. (%)</th>
                        <Field
                          name="da_earnings_per"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          value={`${calculateDAPercentage()} `}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          className={
                            formik1.touched.da_earnings_per &&
                              formik1.errors.da_earnings_per
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={2}
                        xl={2}
                        xxl={2}
                        className=""
                      >
                        {" "}
                        <th style={{ fontFamily: "roboto" }}>D.A.</th>
                        <Field
                          name="da_earnings"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          className={
                            formik1.touched.da_earnings &&
                              formik1.errors.da_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                        <ErrorMessage
                          name="da_earnings"
                          component="div"
                          className="invalid-feedback"
                        />
                      </Col>
                    </Row>
                    <Row> </Row>
                    <Row>
                      {" "}
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          {" "}
                          H.R.A (percentage)
                        </th>

                        <Field
                          name="hra_earnings_per"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          value={`${calculateHRAPercentage()} `}
                          className={
                            formik1.touched.hra_earnings_per &&
                              formik1.errors.hra_earnings_per
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> H.R.A</th>

                        <Field
                          name="hra_earnings"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          className={
                            formik1.touched.hra_earnings &&
                              formik1.errors.hra_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                        <ErrorMessage
                          name="hra_earnings"
                          component="div"
                          className="invalid-feedback"
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> C.C.A</th>

                        <Field
                          name="cca_earnings"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          className={
                            formik1.touched.cca_earnings &&
                              formik1.errors.cca_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> G.P</th>

                        <Field
                          name="gp_earnings"
                          className={
                            formik1.touched.gp_earnings &&
                              formik1.errors.gp_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          IR (percentage)
                        </th>

                        <Field
                          name="ir_earnings_per"
                          className={
                            formik1.touched.ir_earnings_per &&
                              formik1.errors.ir_earnings_per
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          value={`${calculateIRPercentage()} `}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>IR</th>

                        <Field
                          name="ir_earnings"
                          className={
                            formik1.touched.ir_earnings &&
                              formik1.errors.ir_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />

                        <ErrorMessage
                          name="ir_earnings"
                          component="div"
                          className="invalid-feedback"
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> Medical</th>

                        <Field
                          name="medical_earnings"
                          className={
                            formik1.touched.medical_earnings &&
                              formik1.errors.medical_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>C.A</th>

                        <Field
                          name="ca_earnings"
                          className={
                            formik1.touched.ca_earnings &&
                              formik1.errors.ca_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      {" "}
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          Special Allowance.
                        </th>

                        <Field
                          name="spl_all"
                          className={
                            formik1.touched.spl_all && formik1.errors.spl_all
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Misc.(H.C)</th>

                        <Field
                          name="misc_h_c"
                          className={
                            formik1.touched.misc_h_c && formik1.errors.misc_h_c
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          Addl. HRA(Tribal Area)
                        </th>

                        <Field
                          name="addl_hra"
                          className={
                            formik1.touched.addl_hra && formik1.errors.addl_hra
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          SCA(Tribal Area)
                        </th>

                        <Field
                          name="sca"
                          className={
                            formik1.touched.sca && formik1.errors.sca
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={2}
                        xl={2}
                        xxl={2}
                        className=""
                      >
                        <th
                          style={{
                            fontFamily: "roboto",
                            color: "green",
                            fontWeight: "1000",
                          }}
                        >
                          <u>Total Earnings</u>
                        </th>

                        <Field
                          name="totalEarnings"
                          className={
                            formik1.touched.totalEarnings &&
                              formik1.errors.totalEarnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          value={fieldNames
                            .reduce(
                              (total, fieldName) =>
                                total +
                                parseFloat(formik1.values[fieldName] || 0),
                              0
                            )
                            .toLocaleString({
                              style: "currency",
                              currency: "INR",
                              maximumFractionDigits: 0,
                            })}
                          readOnly
                        />
                      </Col>
                    </Row>
                  </div>

                  <div style={{ textAlign: "left" }} id="deductionNames">
                    <h5 style={{ color: "#004687" }}>
                      <b style={{ color: "#0e6793" }}>
                        <u>
                          {" "}
                          <h4 style={{ fontFamily: "times new roman" }}>
                            Deductions
                          </h4>
                        </u>
                      </b>
                    </h5>
                  </div>
                  <div class="col-md-60">
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          GPF(Subscription)
                        </th>

                        <Field
                          name="gpfs_deductions"
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          className={
                            formik1.touched.gpfs_deductions &&
                              formik1.errors.gpfs_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onChange={formik1.handleChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          GPF(Addl. Subscription)
                        </th>

                        <Field
                          name="gpfsa_deductions"
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          className={
                            formik1.touched.gpfsa_deductions &&
                              formik1.errors.gpfsa_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>GPF(Loan)</th>

                        <Field
                          name="gpfl_deductions"
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          className={
                            formik1.touched.gpfl_deductions &&
                              formik1.errors.gpfl_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        {" "}
                        <th style={{ fontFamily: "roboto" }}>
                          APGLI(Subscription)
                        </th>
                        <Field
                          name="apglis_deductions"
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          className={
                            formik1.touched.apglis_deductions &&
                              formik1.errors.apglis_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      {" "}
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        {" "}
                        <th style={{ fontFamily: "roboto" }}>APGLI(Loan)</th>
                        <Field
                          name="apglil_deductions"
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          className={
                            formik1.touched.apglil_deductions &&
                              formik1.errors.apglil_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>GIS</th>

                        <Field
                          name="gis_deductions"
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          className={
                            formik1.touched.gis_deductions &&
                              formik1.errors.gis_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          LIC(Subscription)
                        </th>

                        <Field
                          name="lic_deductions"
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          className={
                            formik1.touched.lic_deductions &&
                              formik1.errors.lic_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>License Fee</th>

                        <Field
                          name="license_deductions"
                          className={
                            formik1.touched.license_deductions &&
                              formik1.errors.license_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      {" "}
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Con.Ded</th>

                        <Field
                          name="con_decd_deductions"
                          className={
                            formik1.touched.con_decd_deductions &&
                              formik1.errors.con_decd_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          EPF (percentage)
                        </th>

                        <Field
                          name="epf_deductions_per"
                          className={
                            formik1.touched.epf_deductions_per &&
                              formik1.errors.epf_deductions_per
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          value={`${calculateEPFPercentage()} `}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>EPF</th>

                        <Field
                          name="epf_deductions"
                          className={
                            formik1.touched.epf_deductions &&
                              formik1.errors.epf_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> EPF Loan</th>

                        <Field
                          name="epf_l_deductions"
                          className={
                            formik1.touched.epf_l_deductions &&
                              formik1.errors.epf_l_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Voluntary PF</th>

                        <Field
                          name="vpf_deductions"
                          className={
                            formik1.touched.vpf_deductions &&
                              formik1.errors.vpf_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>PPF</th>

                        <Field
                          name="ppf_deductions"
                          className={
                            formik1.touched.ppf_deductions &&
                              formik1.errors.ppf_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> RCS Cont</th>

                        <Field
                          name="rcs_cont_deductions"
                          className={
                            formik1.touched.rcs_cont_deductions &&
                              formik1.errors.rcs_cont_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>CM's RF</th>

                        <Field
                          name="cmrf_deductions"
                          className={
                            formik1.touched.cmrf_deductions &&
                              formik1.errors.cmrf_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>FCF</th>

                        <Field
                          name="fcf_deductions"
                          className={
                            formik1.touched.fcf_deductions &&
                              formik1.errors.fcf_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> House Rent</th>

                        <Field
                          name="house_rent_deductions"
                          className={
                            formik1.touched.house_rent_deductions &&
                              formik1.errors.house_rent_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Sal.Rec</th>

                        <Field
                          name="sal_rec_deductions"
                          className={
                            formik1.touched.sal_rec_deductions &&
                              formik1.errors.sal_rec_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>P.T</th>

                        <Field
                          name="pt_deductions"
                          className={
                            formik1.touched.pt_deductions &&
                              formik1.errors.pt_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>I.T.</th>

                        <Field
                          name="it_deductions"
                          className={
                            formik1.touched.it_deductions &&
                              formik1.errors.it_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      {/* <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>Postal RD</th>

                      <Field
                        name="postal_deductions"
                        className={
                          formik1.touched.postal_deductions && formik1.errors.postal_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text" onKeyPress={(e) => NumberValidation(e)}

                        onChange={(e) => {
                          formik1.handleChange(e);
                        }}
                      />
                    </Col> */}
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          Other Liabilities
                        </th>

                        <Field
                          name="other_deductions"
                          className={
                            formik1.touched.other_deductions &&
                              formik1.errors.other_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          maxLength={15}
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={2}
                        xl={2}
                        xxl={2}
                        className=""
                      >
                        <th
                          style={{
                            fontFamily: "roboto",
                            color: "red",
                            fontWeight: "1000",
                          }}
                        >
                          <u>Total Deductions</u>
                        </th>

                        <Field
                          name="totalDeductions"
                          className={
                            formik1.touched.totalDeductions &&
                              formik1.errors.totalDeductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          value={deductionNames
                            .reduce(
                              (total, deductionNames) =>
                                total +
                                parseFloat(formik1.values[deductionNames] || 0),
                              0
                            )
                            .toLocaleString({
                              style: "currency",
                              currency: "INR",
                              maximumFractionDigits: 0,
                            })}
                          readOnly
                        />
                      </Col>
                    </Row>
                  </div>
                  <div style={{ textAlign: "left" }} id="LoanDeductions">
                    <h5 style={{ color: "#004687" }}>
                      <b style={{ color: "#0e6793" }}>
                        <u>
                          {" "}
                          <h4 style={{ fontFamily: "times new roman" }}>
                            Loan Advances
                          </h4>
                        </u>
                      </b>
                    </h5>
                  </div>
                  <Table striped bordered hover id="my-table">
                    <thead className="fw-bold">
                      <tr style={{ backgroundColor: "lightblue" }}>
                        <th style={{ width: "150px" }}></th>
                        <th>
                          <h6>P I </h6>
                        </th>
                        <th>
                          <h6>T I </h6>
                        </th>
                        <th>
                          <h6>AMOUNT</h6>
                        </th>
                        <th style={{ width: "150px" }}></th>
                        <th>
                          <h6>P I </h6>
                        </th>
                        <th>
                          <h6>T I </h6>
                        </th>
                        <th>
                          <h6>AMOUNT</h6>
                        </th>
                      </tr>
                    </thead>
                    <tbody style={{ backgroundColor: "whitesmoke" }}>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          CAR-Principal
                        </td>
                        <td>
                          <Field
                            name="car_a_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.car_a_loanpi &&
                                formik1.errors.car_a_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="car_a_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.car_a_loanti &&
                                formik1.errors.car_a_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="car_a_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.car_a_loan &&
                                formik1.errors.car_a_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          CAR-Interest
                        </td>
                        <td>
                          <Field
                            name="car_i_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.car_i_loanpi &&
                                formik1.errors.car_i_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="car_i_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.car_i_loanti &&
                                formik1.errors.car_i_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="car_i_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.car_i_loan &&
                                formik1.errors.car_i_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Cycle-Principal
                        </td>
                        <td>
                          <Field
                            name="cyc_a_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.cyc_a_loanpi &&
                                formik1.errors.cyc_a_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="cyc_a_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.cyc_a_loanti &&
                                formik1.errors.cyc_a_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="cyc_a_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.cyc_a_loan &&
                                formik1.errors.cyc_a_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Cycle-Interest
                        </td>
                        <td>
                          <Field
                            name="cyc_i_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.cyc_i_loanpi &&
                                formik1.errors.cyc_i_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="cyc_i_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.cyc_i_loanti &&
                                formik1.errors.cyc_i_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="cyc_i_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.cyc_i_loan &&
                                formik1.errors.cyc_i_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          MCA-Principal
                        </td>
                        <td>
                          <Field
                            name="mca_a_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.mca_a_loanpi &&
                                formik1.errors.mca_a_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mca_a_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.mca_a_loanti &&
                                formik1.errors.mca_a_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mca_a_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.mca_a_loan &&
                                formik1.errors.mca_a_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          MCA-Interest
                        </td>
                        <td>
                          <Field
                            name="mca_i_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.mca_i_loanpi &&
                                formik1.errors.mca_i_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mca_i_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.mca_i_loanti &&
                                formik1.errors.mca_i_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mca_i_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.mca_i_loan &&
                                formik1.errors.mca_i_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>

                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          MAR-Principal
                        </td>
                        <td>
                          <Field
                            name="mar_a_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.mar_a_loanpi &&
                                formik1.errors.mar_a_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mar_a_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.mar_a_loanti &&
                                formik1.errors.mar_a_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mar_a_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.mar_a_loan &&
                                formik1.errors.mar_a_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          MAR-Interest
                        </td>
                        <td>
                          <Field
                            name="mar_i_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.mar_i_loanpi &&
                                formik1.errors.mar_i_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mar_i_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.mar_i_loanti &&
                                formik1.errors.mar_i_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="mar_i_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.mar_i_loan &&
                                formik1.errors.mar_i_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          MEDI-Principal
                        </td>
                        <td>
                          <Field
                            name="med_a_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.med_a_loanpi &&
                                formik1.errors.med_a_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="med_a_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.med_a_loanti &&
                                formik1.errors.med_a_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="med_a_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.med_a_loan &&
                                formik1.errors.med_a_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          MEDI-Interest
                        </td>
                        <td>
                          <Field
                            name="med_a_i_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.med_a_i_loanpi &&
                                formik1.errors.med_a_i_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="med_a_i_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.med_a_i_loanti &&
                                formik1.errors.med_a_i_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="med_a_i_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.med_a_i_loan &&
                                formik1.errors.med_a_i_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          HBA
                        </td>
                        <td>
                          <Field
                            name="hba_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hba_loanpi &&
                                formik1.errors.hba_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hba_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hba_loanti &&
                                formik1.errors.hba_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hba_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hba_loan && formik1.errors.hba_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          HBA-Interest
                        </td>
                        <td>
                          <Field
                            name="hba1_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hba1_loanpi &&
                                formik1.errors.hba1_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hba1_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hba1_loanti &&
                                formik1.errors.hba1_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hba1_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hba1_loan &&
                                formik1.errors.hba1_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          ADD HBA
                        </td>
                        <td>
                          <Field
                            name="add_hba_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.add_hba_loanpi &&
                                formik1.errors.add_hba_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="add_hba_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.add_hba_loanti &&
                                formik1.errors.add_hba_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="add_hba_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.add_hba_loan &&
                                formik1.errors.add_hba_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          ADD HBA-Interest
                        </td>
                        <td>
                          <Field
                            name="add_hba1_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.add_hba1_loanpi &&
                                formik1.errors.add_hba1_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="add_hba1_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.add_hba1_loanti &&
                                formik1.errors.add_hba1_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="add_hba1_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.add_hba1_loan &&
                                formik1.errors.add_hba1_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Comp.Adv
                        </td>
                        <td>
                          <Field
                            name="comp_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.comp_loanpi &&
                                formik1.errors.comp_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="comp_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.comp_loanti &&
                                formik1.errors.comp_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="comp_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.comp_loan &&
                                formik1.errors.comp_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Comp.Adv-Interest
                        </td>
                        <td>
                          <Field
                            name="comp1_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.comp1_loanti &&
                                formik1.errors.comp1_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="comp1_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.comp1_loanpi &&
                                formik1.errors.comp1_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="comp1_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.comp1_loan &&
                                formik1.errors.comp1_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          HCESA-Principal
                        </td>
                        <td>
                          <Field
                            name="hcesa_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hcesa_loanpi &&
                                formik1.errors.hcesa_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hcesa_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hcesa_loanti &&
                                formik1.errors.hcesa_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hcesa_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hcesa_loan &&
                                formik1.errors.hcesa_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          HCESA-Interest
                        </td>
                        <td>
                          <Field
                            name="hcesa_i_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hcesa_i_loanpi &&
                                formik1.errors.hcesa_i_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hcesa_i_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hcesa_i_loanti &&
                                formik1.errors.hcesa_i_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hcesa_i_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hcesa_i_loan &&
                                formik1.errors.hcesa_i_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          HBA-Other Dept.
                        </td>
                        <td>
                          <Field
                            name="hbao_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hbao_loanpi &&
                                formik1.errors.hbao_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hbao_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hbao_loanti &&
                                formik1.errors.hbao_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hbao_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hbao_loan &&
                                formik1.errors.hbao_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Personal Bank Loan
                        </td>
                        <td>
                          <Field
                            name="vij_bank_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.vij_bank_loanpi &&
                                formik1.errors.vij_bank_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="vij_bank_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.vij_bank_loanti &&
                                formik1.errors.vij_bank_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="vij_bank_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.vij_bank_loan &&
                                formik1.errors.vij_bank_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          FA
                        </td>
                        <td>
                          <Field
                            name="fa_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.fa_loanpi &&
                                formik1.errors.fa_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="fa_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.fa_loanti &&
                                formik1.errors.fa_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="fa_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.fa_loan && formik1.errors.fa_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          EA
                        </td>
                        <td>
                          <Field
                            name="ea_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.ea_loanpi &&
                                formik1.errors.ea_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="ea_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.ea_loanti &&
                                formik1.errors.ea_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="ea_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.ea_loan && formik1.errors.ea_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Spl.FA
                        </td>
                        <td>
                          <Field
                            name="sfa_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.sfa_loanpi &&
                                formik1.errors.sfa_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="sfa_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.sfa_loanti &&
                                formik1.errors.sfa_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="sfa_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.sfa_loan && formik1.errors.sfa_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Sal.Adv
                        </td>
                        <td>
                          <Field
                            name="sal_adv_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.sal_adv_loanpi &&
                                formik1.errors.sal_adv_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="sal_adv_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.sal_adv_loanti &&
                                formik1.errors.sal_adv_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="sal_adv_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.sal_adv_loan &&
                                formik1.errors.sal_adv_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          HR Arrear
                        </td>
                        <td>
                          <Field
                            name="hr_arrear_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hr_arrear_loanpi &&
                                formik1.errors.hr_arrear_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hr_arrear_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hr_arrear_loanti &&
                                formik1.errors.hr_arrear_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="hr_arrear_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.hr_arrear_loan &&
                                formik1.errors.hr_arrear_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Cell/Telephone Charges
                        </td>
                        <td>
                          <Field
                            name="cell_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.cell_loanpi &&
                                formik1.errors.cell_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="cell_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.cell_loanti &&
                                formik1.errors.cell_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="cell_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.cell_loan &&
                                formik1.errors.cell_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        {" "}
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Staff PL.
                        </td>
                        <td>
                          <Field
                            name="staff_pl_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.staff_pl_loanpi &&
                                formik1.errors.staff_pl_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="staff_pl_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.staff_pl_loanti &&
                                formik1.errors.staff_pl_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="staff_pl_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.staff_pl_loan &&
                                formik1.errors.staff_pl_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            fontWeight: "700",
                            fontFamily: "roboto",
                          }}
                        >
                          Court
                        </td>
                        <td>
                          <Field
                            name="court_loanpi"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.court_loanpi &&
                                formik1.errors.court_loanpi
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="court_loanti"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.court_loanti &&
                                formik1.errors.court_loanti
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                        <td>
                          <Field
                            name="court_loan"
                            onChange={(e) => {
                              formik1.handleChange(e);
                            }}
                            onKeyPress={(e) => NumberValidation(e)}
                            maxLength={15}
                            type="text"
                            className={
                              formik1.touched.court_loan &&
                                formik1.errors.court_loan
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <Row>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={2}
                      xl={2}
                      xxl={2}
                      className=""
                      style={{ marginLeft: "auto" }}
                    >
                      <th
                        style={{
                          fontFamily: "roboto",
                          color: "red",
                          fontWeight: "800",
                        }}
                      >
                        <u>Loan Advances Total</u>
                      </th>

                      <Field
                        name="totalloanAdvances"
                        className={
                          formik1.touched.totalloanAdvances &&
                            formik1.errors.totalloanAdvances
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        value={LoanDeductions.reduce(
                          (total, LoanDeductions) =>
                            total +
                            parseFloat(formik1.values[LoanDeductions] || 0),
                          0
                        ).toLocaleString({
                          style: "currency",
                          currency: "INR",
                          maximumFractionDigits: 0,
                        })}
                        readOnly
                        onChange={(e) => {
                          formik1.handleChange(e);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={2}
                      xl={2}
                      xxl={2}
                      className=""
                      style={{ marginLeft: "auto" }}
                    >
                      <th
                        style={{
                          fontFamily: "roboto",
                          color: "green",
                          fontWeight: "800",
                          fontSize: "",
                        }}
                      >
                        <u>Net Salary</u>
                      </th>

                      <Field
                        name="netSalary"
                        className={
                          formik1.touched.netSalary && formik1.errors.netSalary
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        value={totalSum.toLocaleString({
                          style: "currency",
                          currency: "INR",
                          maximumFractionDigits: 0,
                        })}
                        readOnly
                        onChange={(e) => {
                          formik1.handleChange(e);
                        }}
                      />
                    </Col>
                  </Row>
                </>
              )}
              {saveID === "3" && (
                <>
                  <div style={{ textAlign: "left" }} id="Earnings_3">
                    <h5 style={{ color: "#004687" }}>
                      <b style={{ color: "#0e6793" }}>
                        <u>
                          {" "}
                          <h4 style={{ fontFamily: "times new roman" }}>
                            Earnings
                          </h4>
                        </u>
                      </b>
                    </h5>
                  </div>
                  <div className="col-md-60">
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Place of Work</th>

                        <Field
                          name="os_work_place"
                          className={
                            formik1.touched.os_work_place &&
                              formik1.errors.os_work_place
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onChange={formik1.handleChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> Location</th>

                        <Field
                          name="os_location"
                          className={
                            formik1.touched.os_location &&
                              formik1.errors.os_location
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onChange={formik1.handleChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> Basic Pay</th>

                        <Field
                          name="os_basic_pay_earnings"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          className={
                            formik1.touched.os_basic_pay_earnings &&
                              formik1.errors.os_basic_pay_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> H.R.A</th>

                        <Field
                          name="os_hra_earnings"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          className={
                            formik1.touched.os_hra_earnings &&
                              formik1.errors.os_hra_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Medical</th>

                        <Field
                          name="os_medical_earnings"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          className={
                            formik1.touched.os_medical_earnings &&
                              formik1.errors.os_medical_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>C.A</th>

                        <Field
                          name="os_ca_earnings"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          className={
                            formik1.touched.os_ca_earnings &&
                              formik1.errors.os_ca_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Performance</th>

                        <Field
                          name="os_performance_earnings"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          className={
                            formik1.touched.os_performance_earnings &&
                              formik1.errors.os_performance_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          Employer's Contribution to EPF
                        </th>

                        <Field
                          name="os_ec_epf"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          className={
                            formik1.touched.os_ec_epf && formik1.errors.os_ec_epf
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                        />
                      </Col>
                    </Row>
                  </div>
                  <Row>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={2}
                      xl={2}
                      xxl={2}
                      className=""
                      style={{ marginLeft: "auto" }}
                    >
                      <th
                        style={{
                          fontFamily: "roboto",
                          color: "green",
                          fontWeight: "800",
                        }}
                      >
                        <u>Earnings Total</u>
                      </th>

                      <Field
                        name="totalEarnings_3"
                        className={
                          formik1.touched.totalEarnings_3 &&
                            formik1.errors.totalEarnings_3
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        value={Earnings_3.reduce(
                          (total, Earnings_3) =>
                            total + parseFloat(formik1.values[Earnings_3] || 0),
                          0
                        ).toLocaleString({
                          style: "currency",
                          currency: "INR",
                          maximumFractionDigits: 0,
                        })}
                        readOnly
                        onChange={(e) => {
                          formik1.handleChange(e);
                        }}
                      />
                    </Col>
                  </Row>
                  <div style={{ textAlign: "left" }} id="Deductions_3">
                    <h5 style={{ color: "#004687" }}>
                      <b style={{ color: "#0e6793" }}>
                        <u>
                          {" "}
                          <h4 style={{ fontFamily: "times new roman" }}>
                            Deductions
                          </h4>
                        </u>
                      </b>
                    </h5>
                  </div>
                  <div className="col-md-60">
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          {" "}
                          Employees Share(EPF)
                        </th>

                        <Field
                          name="os_ees_epf_deductions"
                          className={
                            formik1.touched.os_ees_epf_deductions &&
                              formik1.errors.os_ees_epf_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onChange={formik1.handleChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          Employers Share(EPF)
                        </th>

                        <Field
                          name="os_ers_epf_deductions"
                          className={
                            formik1.touched.os_ers_epf_deductions &&
                              formik1.errors.os_ers_epf_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onChange={formik1.handleChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          {" "}
                          Professional Tax
                        </th>

                        <Field
                          name="os_prof_tax_deductions"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          className={
                            formik1.touched.os_prof_tax_deductions &&
                              formik1.errors.os_prof_tax_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          {" "}
                          Other Liabilities
                        </th>

                        <Field
                          name="os_other_deductions"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          className={
                            formik1.touched.os_other_deductions &&
                              formik1.errors.os_other_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                  <Row>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={2}
                      xl={2}
                      xxl={2}
                      className=""
                      style={{ marginLeft: "auto" }}
                    >
                      <th
                        style={{
                          fontFamily: "roboto",
                          color: "red",
                          fontWeight: "800",
                        }}
                      >
                        <u>Deductions Total</u>
                      </th>

                      <Field
                        name="totalDeductions_3"
                        className={
                          formik1.touched.totalDeductions_3 &&
                            formik1.errors.totalDeductions_3
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        value={Deductions_3.reduce(
                          (total, Deductions_3) =>
                            total +
                            parseFloat(formik1.values[Deductions_3] || 0),
                          0
                        ).toLocaleString({
                          style: "currency",
                          currency: "INR",
                          maximumFractionDigits: 0,
                        })}
                        readOnly
                        onChange={(e) => {
                          formik1.handleChange(e);
                        }}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={2}
                      xl={2}
                      xxl={2}
                      className=""
                      style={{ marginLeft: "auto" }}
                    >
                      <th
                        style={{
                          fontFamily: "roboto",
                          color: "green",
                          fontWeight: "800",
                          fontSize: "",
                        }}
                      >
                        <u>NET SALARY</u>
                      </th>

                      <Field
                        name="netSalary_3"
                        className={
                          formik1.touched.netSalary_3 &&
                            formik1.errors.netSalary_3
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        value={totalSum_3.toLocaleString({
                          style: "currency",
                          currency: "INR",
                          maximumFractionDigits: 0,
                        })}
                        readOnly
                        onChange={(e) => {
                          formik1.handleChange(e);
                        }}
                      />
                    </Col>
                  </Row>
                </>
              )}
              {saveID === "4" && (
                <>
                  <div style={{ textAlign: "left" }} id="Earnings_3">
                    <h5 style={{ color: "#004687" }}>
                      <b style={{ color: "#0e6793" }}>
                        <u>
                          {" "}
                          <h4 style={{ fontFamily: "times new roman" }}>
                            Earnings
                          </h4>
                        </u>
                      </b>
                    </h5>
                  </div>
                  <div className="col-md-60">
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>Place of Work</th>

                        <Field
                          name="os_work_place"
                          className={
                            formik1.touched.os_work_place &&
                              formik1.errors.os_work_place
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onChange={formik1.handleChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> Location</th>

                        <Field
                          name="os_location"
                          className={
                            formik1.touched.os_location &&
                              formik1.errors.os_location
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onChange={formik1.handleChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> Earnings</th>

                        <Field
                          name="nmr_gross_earnings"
                          className={
                            formik1.touched.nmr_gross_earnings &&
                              formik1.errors.nmr_gross_earnings
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onChange={formik1.handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                  <Row>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={2}
                      xl={2}
                      xxl={2}
                      className=""
                      style={{ marginLeft: "auto" }}
                    >
                      <th
                        style={{
                          fontFamily: "roboto",
                          color: "darkgreen",
                          fontWeight: "800",
                        }}
                      >
                        <u>Gross Earnings</u>
                      </th>

                      <Field
                        name="totalEarnings_4"
                        className={
                          formik1.touched.totalEarnings_4 &&
                            formik1.errors.totalEarnings_4
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        value={Earnings_4.reduce(
                          (total, Earnings_4) =>
                            total + parseFloat(formik1.values[Earnings_4] || 0),
                          0
                        ).toLocaleString({
                          style: "currency",
                          currency: "INR",
                          maximumFractionDigits: 0,
                        })}
                        readOnly
                        onChange={(e) => {
                          formik1.handleChange(e);
                        }}
                      />
                    </Col>
                  </Row>
                  <div style={{ textAlign: "left" }} id="Deductions_3">
                    <h5 style={{ color: "#004687" }}>
                      <b style={{ color: "#0e6793" }}>
                        <u>
                          {" "}
                          <h4 style={{ fontFamily: "times new roman" }}>
                            Deductions
                          </h4>
                        </u>
                      </b>
                    </h5>
                  </div>
                  <div className="col-md-60">
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>EPF</th>

                        <Field
                          name="os_ees_epf_deductions"
                          className={
                            formik1.touched.os_ees_epf_deductions &&
                              formik1.errors.os_ees_epf_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onChange={formik1.handleChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          {" "}
                          Professional Tax
                        </th>

                        <Field
                          name="os_prof_tax_deductions"
                          className={
                            formik1.touched.os_prof_tax_deductions &&
                              formik1.errors.os_prof_tax_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          onChange={formik1.handleChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> TDS</th>

                        <Field
                          name="nmr_tds_deductions"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          className={
                            formik1.touched.nmr_tds_deductions &&
                              formik1.errors.nmr_tds_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> TDS</th>

                        <Field
                          name="nmr_tds_deductions"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          className={
                            formik1.touched.nmr_tds_deductions &&
                            formik1.errors.nmr_tds_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col> */}
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> FA</th>

                        <Field
                          name="nmr_fa_deductions"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          className={
                            formik1.touched.nmr_fa_deductions &&
                              formik1.errors.nmr_fa_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> EA</th>

                        <Field
                          name="nmr_ea_deductions"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          className={
                            formik1.touched.nmr_ea_deductions &&
                              formik1.errors.nmr_ea_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> MA</th>

                        <Field
                          name="nmr_ma_deductions"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          className={
                            formik1.touched.nmr_ma_deductions &&
                              formik1.errors.nmr_ma_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> LIC</th>

                        <Field
                          name="nmr_lic_deductions"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          className={
                            formik1.touched.nmr_lic_deductions &&
                              formik1.errors.nmr_lic_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}>
                          {" "}
                          Other Liabilities
                        </th>

                        <Field
                          name="nmr_otherliab_deductions"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          className={
                            formik1.touched.nmr_otherliab_deductions &&
                              formik1.errors.nmr_otherliab_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=""
                      >
                        <th style={{ fontFamily: "roboto" }}> Postal RD</th>

                        <Field
                          name="nmr_postalrd_deductions"
                          onChange={(e) => {
                            formik1.handleChange(e);
                          }}
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          className={
                            formik1.touched.nmr_postalrd_deductions &&
                              formik1.errors.nmr_postalrd_deductions
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                  <Row>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={2}
                      xl={2}
                      xxl={2}
                      className=""
                      style={{ marginLeft: "auto" }}
                    >
                      <th
                        style={{
                          fontFamily: "roboto",
                          color: "red",
                          fontWeight: "800",
                        }}
                      >
                        <u>Deductions Total</u>
                      </th>

                      <Field
                        name="totalDeductions_4"
                        className={
                          formik1.touched.totalDeductions_4 &&
                            formik1.errors.totalDeductions_4
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        value={Deductions_4.reduce(
                          (total, Deductions_4) =>
                            total +
                            parseFloat(formik1.values[Deductions_4] || 0),
                          0
                        ).toLocaleString({
                          style: "currency",
                          currency: "INR",
                          maximumFractionDigits: 0,
                        })}
                        readOnly
                        onChange={(e) => {
                          formik1.handleChange(e);
                        }}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={2}
                      xl={2}
                      xxl={2}
                      className=""
                      style={{ marginLeft: "auto" }}
                    >
                      <th
                        style={{
                          fontFamily: "roboto",
                          color: "green",
                          fontWeight: "800",
                          fontSize: "",
                        }}
                      >
                        <u>NET SALARY</u>
                      </th>

                      <Field
                        name="netSalary_4"
                        className={
                          formik1.touched.netSalary_4 &&
                            formik1.errors.netSalary_4
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text"
                        onKeyPress={(e) => NumberValidation(e)}
                        value={totalSum_4.toLocaleString({
                          style: "currency",
                          currency: "INR",
                          maximumFractionDigits: 0,
                        })}
                        readOnly
                        onChange={(e) => {
                          formik1.handleChange(e);
                        }}
                      />
                    </Col>
                  </Row>
                </>
              )}

              {(saveID === "1" || saveID === "2" || saveID === "5") && (
                <center>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => ConfirmEmpUpdateReport()}
                  >
                    Update
                  </button>
                </center>
              )}
              {saveID === "3" && (
                <center>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => ConfirmEmpUpdateReport3()}
                  >
                    Update
                  </button>
                </center>
              )}
              {saveID === "4" && (
                <center>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => ConfirmEmpUpdateReport4()}
                  >
                    Update
                  </button>
                </center>
              )}
            </>
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
}
export default EmpDetailsCommonEdit;
